<template>
  <div class="view-sale">
    <div class="container">
      <div class="view-sale-content">
        <span class="text-block">
          Por algum motivo seu acesso está bloqueado.
        </span>
        <i class="fa-light fa-user-slash py-4"></i>
        <span class="text-block">
          Para mais informações, entre em contato através do email:
        </span>
        <span class="text-block">
          <a :href="`mailto:${email}`">{{ email }}</a>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["setup"]),
    email() {
      return this.setup.metadata_support?.email || "suporte@blitzpay.com.br";
    }
  }
};
</script>
<style lang="scss" scoped>
.view-sale-content {
  margin-top: 200px;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  gap: 8px;
  font-size: 16px;
  i {
    font-size: 40px;
  }
}
</style>
